import React, { useState, useRef, useEffect } from 'react';
import './SidePanel.css';
import TreeView, { siduneaTreeData } from './TreeView';
import DTBuscador from './DTBuscador';
import DTNuevo from './DTNuevo';

const panelMenuData = [
  {
    label: 'Documento',
    items: [
      { label: 'Abrir' },
      { label: 'Cerrar' },
    ],
  },
  {
    label: 'Ver',
    items: [
      { label: 'Actualizar' },
    ],
  },
  {
    label: 'Ayuda',
    items: [
      { label: 'Acerca de' },
    ],
  },
];

const panelItems = [
  { label: 'SIDUNEAWorld' },
  { label: 'International Norms' },
  { label: 'Mi Perfil' },
];

function SidePanel({ onClose }) {
  const [openMenu, setOpenMenu] = useState(null);
  const [contextMenu, setContextMenu] = useState(null);
  const [treeState, setTreeState] = useState({}); // { SIDUNEAWorld: 'expanded' | 'collapsed' | null }
  const [showDTBuscador, setShowDTBuscador] = useState(false);
  const [showDTNuevo, setShowDTNuevo] = useState(false);
  const [savedDTs, setSavedDTs] = useState([]);
  const menuRef = useRef(null);
  const panelRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenMenu(null);
      }
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        setContextMenu(null);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="side-panel">
      {/* Barra de título */}
      <div className="side-panel-titlebar">
        <span className="side-panel-title">Biblioteca de Documentos</span>
        <button className="side-panel-close" onClick={onClose}>×</button>
      </div>

      {/* Menú secundario */}
      <div className="side-panel-menubar" ref={menuRef}>
        {panelMenuData.map((menu, index) => (
          <div className="side-panel-menu-item" key={menu.label}>
            <button
              className={`side-panel-menu-button ${openMenu === index ? 'active' : ''}`}
              onClick={() => setOpenMenu(openMenu === index ? null : index)}
              onMouseEnter={() => openMenu !== null && setOpenMenu(index)}
            >
              {menu.label}
            </button>
            {openMenu === index && (
              <div className="side-panel-dropdown">
                {menu.items.map((item) => (
                  <button
                    className="side-panel-dropdown-item"
                    key={item.label}
                    onClick={() => {
                      console.log(`Panel: ${menu.label} > ${item.label}`);
                      setOpenMenu(null);
                    }}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Lista de items */}
      <div className="side-panel-content" ref={panelRef}>
        {panelItems.map((item) => (
          <React.Fragment key={item.label}>
            <div
              className="side-panel-item"
              onClick={() => {
                if (item.label === 'SIDUNEAWorld') {
                  setContextMenu(contextMenu === item.label ? null : item.label);
                }
              }}
              style={{ position: 'relative' }}
            >
              <span className="side-panel-item-icon">📁</span>
              <span className="side-panel-item-label">{item.label}</span>
              {contextMenu === item.label && (
                <div className="side-panel-context-menu">
                  {['Maximizar', 'Maximizar Todo', 'Minimizar Todo', 'Cerrar'].map((opt) => (
                    <button
                      className="side-panel-context-item"
                      key={opt}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (opt === 'Maximizar Todo') {
                          setTreeState({ ...treeState, [item.label]: 'expanded' });
                        } else if (opt === 'Minimizar Todo') {
                          setTreeState({ ...treeState, [item.label]: null });
                        } else if (opt === 'Cerrar') {
                          setTreeState({ ...treeState, [item.label]: null });
                        }
                        setContextMenu(null);
                      }}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
              )}
            </div>
            {treeState[item.label] === 'expanded' && item.label === 'SIDUNEAWorld' && (
              <div className="side-panel-tree-container">
                <TreeView
                  data={siduneaTreeData}
                  expandAll={true}
                  onContextAction={(nodeLabel, actionLabel) => {
                    if (nodeLabel === 'D/T' && actionLabel === 'Buscar') {
                      setShowDTBuscador(true);
                    }
                    if (nodeLabel === 'D/T' && actionLabel === 'Nuevo') {
                      setShowDTNuevo(true);
                    }
                  }}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
      {showDTBuscador && <DTBuscador onClose={() => setShowDTBuscador(false)} savedDTs={savedDTs} />}
      {showDTNuevo && <DTNuevo onClose={() => setShowDTNuevo(false)} onSaveDT={(dt) => setSavedDTs([...savedDTs, dt])} />}
    </div>
  );
}

export default SidePanel;
